export const Config = {
    auth0Domain: process.env["GATSBY_AUTH0_DOMAIN"] || 'collectoogo-dev.eu.auth0.com',
    auth0ClientId: process.env["GATSBY_AUTH0_CLIENT_ID"] || 'ntMo3dcWEtUSk3kHDA1bOIyRwrkSAWp2',
    auth0CallbackUrl: process.env["GATSBY_AUTH0_CALLBACK_URL"] || 'http://localhost:3000/callback',
    auth0Audience: process.env["GATSBY_AUTH0_AUDIENCE"] || 'https://collectoogo-dev.eu.auth0.com/api/v2/',
    signInUrl: process.env["GATSBY_SIGNIN_URL"] || 'http://localhost:3000/signin',
    signUpUrl: process.env["GATSBY_SIGNUP_URL"] || 'http://localhost:3000/signup'
}